'use client';

import React from 'react';

type FeedbackStarProps = {
  filled?: boolean;
  className?: string;
};

const FeedbackStar = ({ filled = false, className }: FeedbackStarProps) => {
  if (filled) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <path
          d="M12 1.9856L9.49997 9.4856H1.59998L7.99997 14.1856L5.59998 21.7856L12 17.0856L18.4 21.7856L16 14.1856L22.4 9.4856H14.5L12 1.9856Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M12 1.9856L9.49997 9.4856H1.59998L7.99997 14.1856L5.59998 21.7856L12 17.0856L18.4 21.7856L16 14.1856L22.4 9.4856H14.5L12 1.9856Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  );
};

export default FeedbackStar;
